import React from 'react';
import { Container, Row } from 'react-bootstrap';
import useCources from '../../../hooks/useCources';
import SingleCourse from '../Courses/SingleCourses/SingleCourse';


const HomeCource = () => {
    const[course,setCourse]=useCources()
    if(course.length>4){
        const newCoruse= course.slice(0,4)
        setCourse(newCoruse)

    }
    
    return (
        <div>
            <Container >
                <Row>
                    <h3 className="trainer-section-title1">Practice</h3>
                    <h3 className="trainer-section-title2">Home And On-The-Go Classes</h3>
                    
                </Row>
                <Row className='pt-5'>
                    {course.map((crs=><SingleCourse key={crs.id} data={crs}></SingleCourse>))}
                </Row>
            </Container>
        </div>
    );
};

export default HomeCource;